import {
  Component,
  ElementRef,
  HostBinding,
  Renderer2,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  SimpleChanges,
  OnChanges,
} from '@angular/core';

export type CollapseDirection = 'none' | 'left' | 'right' | 'top' | 'bottom';

import { SplitterPaneComponent } from '../../../../../kendo/kendo-angular-layout/splitter/splitter-pane.component';

@Component({
  standalone: false,
  exportAs: 'tiKendoSplitterPane',
  selector: 'ti-kendo-splitter-pane, kendo-splitter-pane',
  template: `
    <ng-container *ngIf="!collapsed"><ng-content></ng-content></ng-container>
    <div *ngIf="overlayContent && !forceDisableOverlay" class="k-splitter-overlay k-overlay"></div>
  `,
})
export class TiSplitterPaneComponent extends SplitterPaneComponent implements OnChanges {
  @Input()
  public containerId: string = 'default-container';

  @Input()
  public collapsed: boolean = false;

  @Input()
  public hiddenBar: boolean = false;

  @Input()
  public collapseDirection: CollapseDirection;

  @Input()
  public splitterBarIconClass: string = '';

  @Input()
  public splitterBarLabel: string = '';

  @Input()
  public splitterBarQAId: string = '';

  @Input()
  public overlayContent: boolean = false;

  @Input()
  public forceDisableOverlay: boolean = false;

  @Input()
  public linkName: string = '';

  @Output() collapseChangeRequred = new EventEmitter<boolean>();

  collapse(collapse: boolean) {
    this.collapseChangeRequred.emit(collapse);
  }

  @HostBinding('class.collapsed')
  public get isHidden(): boolean {
    return this.collapsed;
  }
  private addClass(cssClass: string) {
    this.tiRenderer.addClass(this.tiElement.nativeElement, cssClass);
  }

  private removeClass(cssClass: string) {
    this.tiRenderer.removeClass(this.tiElement.nativeElement, cssClass);
  }

  public clearStaticState() {
    this.removeClass('k-pane-static');
  }

  public addGrowSpaceClass() {
    this.addClass('ti-k-grow-space-pane');
  }

  public removeGrowSpaceClass() {
    this.removeClass('ti-k-grow-space-pane');
  }

  public inheritCollapsibleState(pane: TiSplitterPaneComponent) {
    return pane.collapsed || (this.collapsed && !pane.collapsed);
  }

  constructor(
    public tiElement: ElementRef,
    public tiRenderer: Renderer2,
    public cd: ChangeDetectorRef,
  ) {
    super(tiElement, tiRenderer);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.collapsed) {
      this.collapse(changes.collapsed.currentValue);
    }
  }
}
